import {
  CertificationDefault,
  ContactMethod,
  CustomValue,
  Invite,
  TermsOfService,
  UserMemory,
  UserPermissions
} from '@queries/generated';

export enum UserRoleType {
  Vendor = 'vendor',
  Author = 'author',
  TrainingManager = 'training_manager',
  Impersonator = 'impersonator',
  ILManager = 'il_manager',
  Instructor = 'instructor'
}

export class CurrentUser {
  id: number;
  gid: string;
  firstName: string;
  lastName: string;
  fullName: string;
  email: string;
  locale: string;
  mobileNumber: string;
  persona: string;
  roles: string[];
  can: UserPermissions;
  contactMethods?: ContactMethod[];
  receivedInvites?: Invite[];
  customValues?: CustomValue[];
  allowVenomOptOut?: boolean;
  impersonatedBy: { id: number; fullName: string };
  certificationDefault?: CertificationDefault;
  timeZone: string;
  hasStripeSubscriptions: boolean;
  pendingTermsOfServices?: TermsOfService[];
  mightBeTrainingManager: boolean;
  memories: UserMemory[];

  constructor(attributes?: Object) {
    Object.assign(this, attributes);
  }

  is(role: string): boolean {
    return this.roles.includes(role);
  }

  isOnly(role: string): boolean {
    return this.is(role) && this.roles.length === 1;
  }
}
